import React from 'react'

import withDefaultStyles from './withDefaultStyles'

const InvestigationStepFlag = () => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M18.0199 12.33L16.7999 11.11C16.5099 10.86 16.3399 10.49 16.3299 10.08C16.3099 9.63 16.4899 9.18 16.8199 8.85L18.0199 7.65C19.0599 6.61 19.4499 5.61 19.1199 4.82C18.7999 4.04 17.8099 3.61 16.3499 3.61H5.8999V2.75C5.8999 2.34 5.5599 2 5.1499 2C4.7399 2 4.3999 2.34 4.3999 2.75V21.25C4.3999 21.66 4.7399 22 5.1499 22C5.5599 22 5.8999 21.66 5.8999 21.25V16.37H16.3499C17.7899 16.37 18.7599 15.93 19.0899 15.14C19.4199 14.35 19.0399 13.36 18.0199 12.33Z"
      fill="currentColor"
    />
  </svg>
)

export default withDefaultStyles(InvestigationStepFlag)
